// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___xb_qy","root__item":"style-module__root__item___V5JPW","root__item_active":"style-module__root__item_active___KHgFc"};
    if(module.hot) {
      // 1697460464495
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  